import React from "react";
import { useHistory } from "react-router-dom";
import locale from "localization";
import styles from "./view-voucher-campaign.module.scss";
import { FormMode } from "enums";
import { Path } from "enums";
import { Intro, BackLink } from "components/commons";
import VoucherCampaignDetailsModule from "../voucher-campaign-details/voucher-campaign-details.module";

const ViewVoucherCampaign = (props) => {
  const history = useHistory();
  const editable = props.location.state ? props.location.state.editable : "";
  const voucherCampaignId = props.location.state ? props.location.state.voucherCampaignId : "";
  return (
    <div>
      <BackLink text={locale.voucherCampaigns} path={Path.Campaigns} />
      <div className={styles.intro}>
        <Intro
          title={locale.voucherCampaignDetails}
          actionSecondaryText={editable ? locale.edit : null}
          actionSecondaryOnClick={() => {
            history.push(Path.EditVoucherCampaign, {
              voucherCampaignId,
            });
          }}
          actionSecondaryClassName={styles.primaryEditButton}
          actionStartIcon={<span className="icon-pencil" />}
        />
        <VoucherCampaignDetailsModule
          pageMode={FormMode.View}
          voucherCampaignId={voucherCampaignId}
        />
      </div>
    </div>
  );
};

export default ViewVoucherCampaign;
